import React, { Component } from 'react';
import styled from 'styled-components';
import { withRouter } from 'react-router-dom';
import mediaWidth from '../../../utils/mediaWidth/mediaWidth';
import { Font, FontWeight } from '../../../utils/fonts';

// import Analytics from '../../../services/Analytics';

import Input from '../Input';
import SubmitButton from '../../../components/SubmitButton';
import phoneMaskFunction from '../phoneMaskFunction';
import validateName from '../validateName';
import validateContact from '../validateContact';

const tabs = {
    email: 'почте',
    phone: 'телефону',
};

class Form extends Component {
    constructor(props) {
        super(props);
        this.state = {
            values: {
                name: '',
                email: '',
                phone: '',
                company: '',
                position: '',
            },
            isActive: tabs.email,
            isSubmitEnable: false,
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.validateValues = this.validateValues.bind(this);
        this.handleNameInput = this.handleNameInput.bind(this);
        this.handleEmailInput = this.handleEmailInput.bind(this);
        this.handlePhoneInput = this.handlePhoneInput.bind(this);
        this.activateTab = this.activateTab.bind(this);
    }

    validateValues() {
        const { values } = this.state;
        let isEnable;
        if (validateName(values.name) && validateContact(values.email, values.phone)) {
            isEnable = true;
        } else {
            isEnable = false;
        }
        this.setState({ isSubmitEnable: isEnable });
    }

    handleNameInput(event) {
        const { values } = this.state;
        const { value } = event.target;
        this.setState({ values: { ...values, name: value } }, () => {
            this.validateValues();
        });
    }

    handleEmailInput(event) {
        const { values } = this.state;
        const { value } = event.target;
        this.setState({ values: { ...values, email: value } }, () => {
            this.validateValues();
        });
    }

    handlePhoneInput(event) {
        const { values } = this.state;
        const { value } = event.target;
        const maskedValue = phoneMaskFunction(value, values.phone);
        this.setState({ values: { ...values, phone: maskedValue } }, () => {
            this.validateValues();
        });
    }

    handleSubmit() {
        const { onClick } = this.props;
        const { values } = this.state;
        const data = { ...values };
        onClick(data);
        // this.sendAnalytics();
    }

    // sendAnalytics() {
    //     const { location: { pathname } } = this.props;
    // }

    activateTab(name) {
        this.setState({ isActive: name });
    }

    render() {
        const { className } = this.props;
        const {
            values,
            isSubmitEnable,
            isActive,
        } = this.state;

        return (
            <Root className={className}>
                <InputStyled
                    title="name"
                    lable="Имя"
                    value={values.name}
                    onChange={this.handleNameInput}
                    type="text"
                    errorMessage="Обязательно для заполнения"
                    required
                />
                <Wrapper>
                    <NavMenu>
                        Связаться&nbsp;по
                        {' '}
                        <Buttons>
                            <Button
                                name={tabs.email}
                                isActive={isActive}
                                onClick={() => this.activateTab(tabs.email)}
                            >
                                {tabs.email}
                            </Button>
                            <Button
                                name={tabs.phone}
                                isActive={isActive}
                                onClick={() => this.activateTab(tabs.phone)}
                            >
                                {tabs.phone}
                            </Button>
                        </Buttons>
                    </NavMenu>
                    {
                        isActive === tabs.email ? (
                            <InputStyledEmail
                                title="email"
                                lable="Email"
                                value={values.email}
                                onChange={this.handleEmailInput}
                                type="email"
                                errorMessage="Заполните email или телефон"
                                required
                            />
                        ) : (
                            <InputStyledPhone
                                title="phone"
                                lable="Телефон"
                                value={values.phone}
                                onChange={this.handlePhoneInput}
                                type="phone"
                                errorMessage="Заполните email или телефон"
                                required
                            />
                        )
                    }
                </Wrapper>
                <LinkPolicy>
                    Нажимая кнопку «Отправить», я соглашаюсь на обработку персональных
                    данных в соотвествии
                    {' '}
                    <a href="/documents/personal_data_policy.pdf" target="_blank">
                        с политикой об обработке персональных данных
                    </a>
                </LinkPolicy>
                <SubmitButtonStyled isActive={isSubmitEnable} onClick={this.handleSubmit} />
            </Root>
        );
    }
}

const Root = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;

    background: transparent;

    ${Font.PRIMARY};
    ${FontWeight.REGULAR};
`;

const Wrapper = styled.div``;

const LinkPolicy = styled.div`
    font-size: 12px;
    ${Font.PRIMARY};
    ${FontWeight.REGULAR};
`;

const NavMenu = styled.div`
    display: flex;
    margin-top: 20px;

    font-size: 18px;
    line-height: 23px;
    ${Font.PRIMARY};
    ${FontWeight.REGULAR};

    border-bottom: 1px solid rgba(0, 0, 0, .16);
    -webkit-tap-highlight-color: transparent;
`;

const Buttons = styled.div`
    display: flex;
    cursor: pointer;
`;

const Button = styled.div`
    margin-left: 10px;
    color: ${({ isActive, name }) => (isActive === name ? '#0032A0' : 'rgba(0, 0, 0, .3)')};
    border-bottom: ${({ isActive, name }) => (isActive === name ? '5px solid #0032A0' : 'none')};
    padding-bottom: 14px;
`;

const InputStyled = styled(Input)``;

const InputStyledEmail = styled(Input)``;

const InputStyledPhone = styled(Input)``;

const SubmitButtonStyled = styled(SubmitButton)`
    margin: 40px auto 0px;

    ${mediaWidth.l} {
        margin: 48px auto 0px;
    }
`;

export default withRouter(Form);
